<template>
    <div id="index" class="animate-in">
        <!--顶部搜索筛选-->
        <div class="row">
            <div class="col-md-12">
                <div class="box fz-content-box">
                    <div class="box-body fz-box-body">
                    
                        <form class="form-inline searchForm" id="searchForm" action="#" method="GET">
                            <div class="form-group mr15"><span class="fz-menu-name">{{menuName}}</span></div>

                            <div class="form-group">
                                <input value=""
                                    name="_keywords" v-model="searchKey" id="_keywords" class="form-control input-sm fz-input-radiu" placeholder="输入订单号">
                            </div>
                            <div class="form-group">
                                <a href="#" class="fz-goto-search" @click="toSearch">
                                    <i class="fa fa-search"></i>
                                </a>
                            </div>

                            <div class="form-group fz-input-time ml30">			
                                <div class="input-group date fz-input-time-width" id="datetimepicker1">
                                    <input type="text" class="timeInput form-control input-sm fz-input-radiu" id="startTime" v-model="startTime" readonly />
                                    <span class="input-group-addon fz-group-addon-width">
                                        <span class="glyphicon glyphicon-calendar"></span>
                                    </span>
                                </div>
                                <span class="fz-color-white">&nbsp;至&nbsp;</span>         
                                <div class="input-group date fz-input-time-width"  id="datetimepicker2">
                                    <input type="text" class="timeInput form-control input-sm fz-input-radiu" id="endTime" v-model="endTime" readonly />
                                    <span class="input-group-addon fz-group-addon-width">
                                        <span class="glyphicon glyphicon-calendar"></span>
                                    </span>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--数据列表页面-->
        <section class="content">
            <div class="row">
                <div class="col-md-12">
                    <div class="box fz-box">
                        <div class=" table-responsive">
                            <table class="table table-hover fz-table-hover fz-table-bordered datatable" width="100%">
                                <thead>
                                <tr class="fz-gray">
                                    <th>ID</th>
                                    <th>用户</th>
                                    <th>产品</th>
                                    <th>数量</th>
                                    <th>状态</th>
                                    <th>支付总额</th>
                                    <th>订单号</th>
                                    <th>类型</th>
                                    <th>下单时间</th>
                                    <th>支付时间</th>
                                    <th>操作</th>
                                    
                                </tr>
                                </thead>
                                <tbody>
                                
                                <tr v-for="(item,index) in currentList" :key="item.key" :class="[index===1?'active':'']">
                                    <td>{{item.id}}</td>
                                    <td>{{item.user.name}}</td>
                                    <td>{{item.product.name}}({{item.product_rule}})</td>
                                    <td>{{item.num}}</td>
                                    <td>
                                        <span v-if="item.status==0" class="text-red"> 待支付 </span>
                                        <span v-if="item.status==1" class="text-warning"> 待发货 </span>
                                        <span v-if="item.status==2" class="text-info"> 待收货 </span>
                                        <span v-if="item.status==3" class="text-success"> 已完成 </span>
                                        <span v-if="item.status==4" class="text-gray"> 已取消 </span>
                                         <span v-if="item.status==5" class="text-purple"> 退货中 </span>
                                        <span v-if="item.status==6" class="text-info"> 已退货 </span>
                                    </td>
                                    <td>{{item.money}}</td>
                                    <td>{{item.sn}}</td>
                                    <td>产品订购</td>
                                    <td>{{item.create_time }}</td>
                                    <td>{{item.success_time }}</td>
                                    <td> <a @click="showOrderDetail(item)" class="btn btn-xs btn-default">查看</a> </td>
                                </tr>
                                
                                </tbody>
                            </table>
                        </div>

                    </div>
                    <!-- 数据列表底部 -->
                    <div class="fz-box-footer center-block text-center">
                       <pagination :offset="current_page" :num="num" :limit="limit" @getNew="changePage"></pagination>
                    </div>
                </div>
            </div>
        </section> 

         <transition name="el-fade-in">
            <v-drag v-if="isShowOrderDetail" :title="'订单详情'" 
             :hiddenCancel="true"  @cancel="isShowOrderDetail= false" :hiddenConfirm="true"  :widthData="'450px'">

                    <div style="padding:20px" >
                         <table class="table table-hover fz-table-hover ">
                            <tbody>
                             <tr><th>订单编号</th><td>{{ selectedOrder.sn}}</td></tr>
                             <tr><th>微信订单号</th><td>{{ selectedOrder.trade_no}}</td></tr>
                             <tr><th>订单状态</th><td>
                                 <span v-if="selectedOrder.status==0" class="text-red"> 待支付 </span>
                                        <span v-if="selectedOrder.status==1" class="text-warning"> 待发货 </span>
                                        <span v-if="selectedOrder.status==2" class="text-info"> 待收货 </span>
                                        <span v-if="selectedOrder.status==3" class="text-success"> 已完成 </span>
                                        <span v-if="selectedOrder.status==4" class="text-gray"> 已取消 </span>
                                        <span v-if="selectedOrder.status==5" class="text-purple"> 退货中 </span>
                                        <span v-if="selectedOrder.status==6" class="text-info"> 已退货 </span>
                                 </td></tr>
                             <tr><th>产品</th><td>{{selectedOrder.product.name}}({{selectedOrder.product_rule}})</td></tr>
                             <tr><th>支付总额</th><td>{{ selectedOrder.money}}</td></tr>
                             <tr><th>收件人</th><td>{{ selectedOrder.ship_name}}</td></tr>
                             <tr><th>电话</th><td>{{ selectedOrder.ship_phone}}</td></tr>
                             <tr><th>地址</th><td>{{ selectedOrder.address}}</td></tr>
                            </tbody>
                         </table>
                    </div>
                    <div style="padding:0 20px;"  v-if="selectedOrder.status==5">
                        <button @click="returnMoney(selectedOrder)" class="btn pull-right btn-warning btn-xs">确认退款</button>
                    </div>
                    
            </v-drag>
        </transition>

    </div>
</template>

<script>
import pagination from "@/components/pagination.vue"
import '@/static/plugins/bootstrap-datetimepicker/js/bootstrap-datetimepicker.js';
import '@/static/plugins/bootstrap-datetimepicker/js/locales/bootstrap-datetimepicker.zh-CN.js';
import '@/static/plugins/bootstrap-datetimepicker/css/bootstrap-datetimepicker.css';
import {req, reqFile} from "../../api/axiosFun"
import vDrag from "@/components/dragDiv.vue"
export default {
    name: 'order',
    data() {
        return {
            selectedOrder:{},
            menuName: "订单查询",
            loading: false, //是显示加载
            isShowOrderDetail: false, //是显示加载
            current_page:1,
            startTime: "",
            searchKey: "",
            endTime: "",
            listData: [],
            currentList: [],
            // 分页参数
            num: 1,
            limit: 12,
        }
    },
    components: {
        pagination,vDrag
    },
    created() {
        
    }, 
    mounted() {
      //  this.getNew(0);
    //    this.num = this.listData.length;
        //必须在组件渲染之后调用
        this._dateDefault();
          this.requestData(); 
    },
    methods: {
        _dateDefault() {
            let _this = this;
            $('#datetimepicker1').datetimepicker({
                language:  'zh-CN',
                format: 'yyyy-mm-dd hh:ii',
                weekStart: 1,
                todayBtn:  1,
                autoclose: 1,
                todayHighlight: 1,
                startView: 2,
                minView: 0,
                maxView: 1,
                forceParse: 0,
            }).on("hide", function(ev) {
                var value = $("#startTime").val();
                _this.startTime = value;
            });

            $('#datetimepicker2').datetimepicker({
                language:  'zh-CN',
                format: 'yyyy-mm-dd hh:ii',
                weekStart: 1,
                todayBtn:  1,
                autoclose: 1,
                todayHighlight: 1,
                startView: 2,
                minView: 0,
                maxView: 1,
                forceParse: 0,
            }).on("hide", function(ev) {
                var value = $("#endTime").val();
                _this.endTime = value;
            });
        },

        showOrderDetail(item) {
            this.isShowOrderDetail = true;
            this.selectedOrder = item;
        },
         async  requestData() {
          this.canRefresh = false;
          let res = await  req('GET', '/shop-order?page=' + this.current_page +'&limit=' + this.limit +'&k='+this.searchKey );
            if(res) {
                    this.listData = res.data.data;
                    this.currentList = res.data.data;
                    this.next_page = res.data.current_page >= res.data.last_page ? res.data.current_page:res.data.current_page + 1;
                    this.num =  res.data.total ;
            }
            this.$parent.isLoading  = false;
            this.resload = 10;
            this.canRefresh = true;
           
        },
         async  returnMoney(order) {
          this.canRefresh = false;
           try {
                let res = await  req('POST', '/shop-order/money/' + order.id );
                if(res.res=='ok') {
                            this.$toast.open({
                            message:'退款成功!',
                            type:'success',
                            position:'top'
                        });
                } else {
                            this.$toast.open({
                            message:'操作失败!',
                            type:'error',
                            position:'top'
                        });
                }
           } catch(e) {
                 this.$toast.open({
                            message:'操作失败!',
                            type:'error',
                            position:'top'
                        });
           }
           this.isShowOrderDetail = false;
            this.$parent.isLoading  = false;
            this.resload = 10;
            this.canRefresh = true;
           
        },

         changePage(page){
     
             this.$router.push({
                path: '/business/order?page=' + this.current_page,
                query: {
                    site: [],
                    bu: []
                }
                })
             this.requestData();
        },


        getNew(value) {
            console.log(value);
            this.currentList = this.listData.slice(value, value + this.limit);
            console.log(this.currentList);
        },
        toSearch() {
            this.current_page = 1;
            this.requestData();
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
